export default "__VITE_ASSET__62r2n$8r__"